import { Injectable }      from '@angular/core';
import { BrandService }    from '@core/services/brand/brand.service';
import {
	Actions,
	createEffect,
	ofType
}                          from '@ngrx/effects';
import { KeycloakService } from 'keycloak-angular';
import { switchMap }       from 'rxjs/operators';
import * as featureActions from './actions';

@Injectable( {
	providedIn: 'root'
} )
export class CurrentUserEffects {

	logoutRequestEffect = createEffect( () => {
		return this.actions$.pipe(
			ofType<featureActions.LogoutRequestAction>(
				featureActions.ActionTypes.LOGOUT_REQUEST
			),
			switchMap( action => {
					return this.keycloakService.logout( this.brandService.logoutUrl )
					.then( ( res: any ) => new featureActions.LogoutSuccessAction( res ) )
					.catch( error => new featureActions.LogoutFailureAction( error ) );
				}
			)
		);
	} );

	// TODO use effects instead workaround on comps when service usage/ui load issue is solved
	// manageTenantActive = createEffect( () => {
	// 	return this.actions$.pipe(
	// 		ofType<featureActions.ManageTenantActive>(
	// 			featureActions.ActionTypes.MANAGE_TENANT_ACTIVE
	// 		),
	// 		switchMap( action => {
	// 				this.tenantDashboardService.navigateToStatistics();
	// 				return [];
	// 			}
	// 		)
	// 	);
	// } );


	// TODO use effects instead workaround on comps when service usage/ui load issue is solved
	// manageTenantInactive = createEffect( () => {
	// 	return this.actions$.pipe(
	// 		ofType<featureActions.ManageTenantInactive>(
	// 			featureActions.ActionTypes.MANAGE_TENANT_INACTIVE
	// 		),
	// 		switchMap( action => {
	// 				this.tenantHelperService.currentUsersRoleBasedTenantService.navigateToListPage();
	// 				return [];
	// 			}
	// 		)
	// 	);
	// } );

	constructor(
		private readonly keycloakService: KeycloakService,
		private readonly actions$: Actions,
		private readonly brandService: BrandService
		// TODO for some reason ui is not loading when these are uncommented
		// private readonly tenantHelperService: TenantHelperService,
		// private readonly tenantDashboardService: TenantDashboardService,
	) {}
}
